export default __webpack_public_path__ + "static/media/letterY.331315c9.svg";